var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendorTickerIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.25V16.1875C19 14.6555 19 13.8894 18.524 13.4135C18.0481 12.9375 17.282 12.9375 15.75 12.9375L12.5 20.25L9.25 12.9375C7.71793 12.9375 6.9519 12.9375 6.47595 13.4135C6 13.8894 6 14.6555 6 16.1875V20.25",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.5625L12.0938 17.8125L12.5 19.0312L12.9062 17.8125L12.5 14.5625ZM12.5 14.5625L11.6875 12.9375H13.3125L12.5 14.5625Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3438 7.65625V6.84375C15.3438 5.2732 14.0706 4 12.5 4C10.9294 4 9.65625 5.2732 9.65625 6.84375V7.65625C9.65625 9.22681 10.9294 10.5 12.5 10.5C14.0706 10.5 15.3438 9.22681 15.3438 7.65625Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorTickerIc);
export default __webpack_public_path__ + "static/media/vendor_ticker_ic.2c248875226a1b7985e4423a4b5b0da3.svg";
export { ForwardRef as ReactComponent };